import React, {useEffect} from 'react';
import Modal from "../../../components/modal";
import PayoutBox1 from "./PayoutBox1";

let timeout;

const Payout = ({show, setOpenFn}) => {

    useEffect(() => {
        return () => {
            clearTimeout(timeout);
        }
    }, [])

    const closeModal = () => {
        const modalBackdrop = document.querySelector('.modal-backdrop');
        const modal = document.querySelector('.modal');
        modalBackdrop.style.animation = 'fadeOut 0.3s forwards';
        modal.style.animation = 'slideUp 0.3s forwards';

        timeout = setTimeout(() => {
            setOpenFn(false);
        }, 300);
    };
    return (
        <Modal isOpen={show} onClose={closeModal}>
            <PayoutBox1 closeModal={closeModal} />
        </Modal>
    );
}

export default Payout;
